import { Suspense, useState } from 'react';
import { hydrate, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { I18nProvider } from '@cx-modules/i18n-provider';

import type { OffersSlimIndexProps } from '../contract';

import { OffersSlim } from './OffersSlim';

const createQueryClient = (nocache?: boolean) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: nocache ? 0 : undefined,
        refetchOnMount: nocache ? true : false,
        staleTime: nocache ? 0 : Infinity,
      },
    },
  });

export default function OffersSlimWithQuery({ dehydratedState, loadingSlot, nocache, ...props }: OffersSlimIndexProps) {
  const [queryClient] = useState(() => {
    const client = createQueryClient(nocache);
    hydrate(client, dehydratedState);
    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider i18nInstance={props.i18n}>
        <Suspense fallback={loadingSlot ?? <div>Loading...</div>}>
          <OffersSlim {...props} />
        </Suspense>
      </I18nProvider>
    </QueryClientProvider>
  );
}

export { loadDataForServer } from './loadData';
export type { OffersSlimIndexProps } from '../contract';
